import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretDownFilled, CaretRightFilled, DownOutlined, RightOutlined } from "@ant-design/icons-svg";
import { useMemo } from "react";
import { findUsedDeclarations } from "@devowl-wp/cookie-consent-web-client";
import { useBanner } from "../../../contexts/banner.js";
import { AccordionItem, AccordionList } from "../../common/accordionItem.js";
const BannerTcfStacks = ()=>{
    const banner = useBanner();
    const { tcf: { gvl, model }, texts: { tcfStacksCustomName, tcfStacksCustomDescription }, bodyDesign: { accordionArrowType }, isListServicesNotice } = banner;
    const { vendors, stacks, purposes: { 1: purpose1 } } = gvl;
    // Always show Purpose #1 in initial layer, but first check if it is generally in use
    const usesPurpose1 = useMemo(()=>{
        const legInt = findUsedDeclarations("purposes", gvl, model, "legInt").filter((param)=>{
            let { id } = param;
            return id === 1;
        });
        const consent = findUsedDeclarations("purposes", gvl, model, "consent").filter((param)=>{
            let { id } = param;
            return id === 1;
        });
        return legInt.length > 0 || consent.length > 0;
    }, [
        vendors,
        gvl,
        model
    ]);
    const icon = accordionArrowType !== "none" ? accordionArrowType === "filled" ? CaretRightFilled : RightOutlined : undefined;
    const iconExpanded = accordionArrowType !== "none" ? accordionArrowType === "filled" ? CaretDownFilled : DownOutlined : undefined;
    return /*#__PURE__*/ _jsxs(AccordionList, {
        children: [
            usesPurpose1 && /*#__PURE__*/ _jsx(AccordionItem, {
                title: purpose1.name,
                icon: icon,
                iconExpanded: iconExpanded,
                children: purpose1.description
            }),
            Object.values(stacks).map((param)=>{
                let { id, name, description } = param;
                return /*#__PURE__*/ _jsx(AccordionItem, {
                    title: name,
                    icon: icon,
                    iconExpanded: iconExpanded,
                    children: description
                }, id);
            }),
            !isListServicesNotice && /*#__PURE__*/ _jsx(AccordionItem, {
                title: tcfStacksCustomName,
                icon: icon,
                iconExpanded: iconExpanded,
                children: tcfStacksCustomDescription
            })
        ]
    });
};
export { BannerTcfStacks };
